import { Stepper } from '@mantine/core';
import { IconCheck } from 'ui-icons';

import classes from './Stepper.module.css';

const StepperDefaults = Stepper.extend({
  defaultProps: {
    completedIcon: <IconCheck />,
  },
  classNames: {
    root: classes.root,
    stepIcon: classes.stepIcon,
    separator: classes.separator,
    stepBody: classes.stepBody,
    stepLabel: classes.stepLabel,
    stepDescription: classes.stepDescription,
  },
});

export { StepperDefaults };
